export default class SpinnerButton {
    constructor(options) {
        this.collection = options.collection;

        this.dom = { el: options.el };

        this.events();
    }

    events() {
        // Works but not ideal still missing golbal event concept
        // Need to add and remove event listeners so we don't have duplicates
        // and keep inside click so we only trigger on button we are pressing
        this.dom.el.addEventListener("click", e => {
            e.preventDefault();

            if (!e.target.classList.contains("noswatches")) {
                if (!this.dom.el.classList.contains("success")) {
                    this.dom.el.classList.add("loading");
                }

                this.collection.bus.addEventListener("success", () => {
                    this.success();
                });

                this.collection.bus.removeEventListener("success", () => {});
            }
        });
    }

    success() {
        const addToCart = document.querySelector("#add-to-cart");
        const addToCollection = document.querySelector("#add-to-collection");

        if (addToCollection.classList.contains("loading")) {
            addToCollection.classList.remove("loading");
            addToCollection.classList.add("success");
        } else if (addToCart.classList.contains("loading")) {
            addToCart.classList.remove("loading");
            addToCart.classList.add("success");
        } else if (this.dom.el.classList.contains("loading")) {
            this.dom.el.classList.remove("loading");
            this.dom.el.classList.add("success");
        }
    }
}
